import { Group, Skeleton, Stack, Text, Title, useMantineTheme } from '@mantine/core';
import { IconCoin } from '@tabler/icons-react';
import { getBalanceColor } from 'app/Private/Clients/Detail/BalanceTab';
import { useDebtor } from 'app/Private/Clients/Detail/client-atom';
import { Ticker } from 'components/Ticker';
import { i18nKeys, useTranslation } from 'locales';
import { useHistory } from 'react-router';
import { useLoadDebtorBalance } from 'shared/hooks/use-load-debtor-balance';
import { useLocalizedCurrencyFormatter } from 'shared/utils/currency';
import { computeDebtorBalance } from '../../BalanceTab/ComputeDebtorBalance';

export const BalanceInfoPanel = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const theme = useMantineTheme();
  const debtor = useDebtor();

  const formatter = useLocalizedCurrencyFormatter();

  const { debtorBalance, isDebtorBalanceInitialLoading, debtorBalanceError } = useLoadDebtorBalance(
    String(debtor.id),
    true,
  );

  const handleTabChange = () => history.replace(`#balance-detail`);

  if (debtorBalanceError)
    return (
      <Ticker
        h="100%"
        title={t(i18nKeys.CLIENT.DETAIL.REMAIN_BALANCE).toUpperCase()}
        topRight={<IconCoin size={18} color={theme.colors.gray[6]} />}
      >
        <Text size="sm" c="dimmed">
          {t(i18nKeys.CLIENT.GENERAL_INFO_TAB.COULD_NOT_FETCH)}
        </Text>
      </Ticker>
    );

  if (isDebtorBalanceInitialLoading)
    return (
      <Ticker
        h="100%"
        title={t(i18nKeys.CLIENT.DETAIL.REMAIN_BALANCE).toUpperCase()}
        onClick={handleTabChange}
        topRight={<IconCoin size={18} color={theme.colors.gray[6]} />}
      >
        <Stack gap={4}>
          <Skeleton height={30} width={100} />
          <Skeleton height={18} width={120} />
        </Stack>
      </Ticker>
    );

  if (!debtorBalance) return null;

  const { remainingBalance, openInvoices } = computeDebtorBalance(debtorBalance);

  // remaining balance counts late fees
  return (
    <Ticker
      title={t(i18nKeys.CLIENT.GENERAL_INFO_TAB.PANEL_TITLE.BALANCE).toUpperCase()}
      onClick={handleTabChange}
      topRight={<IconCoin size={18} color={theme.colors.gray[6]} />}
    >
      <Stack gap={0}>
        <Title c={getBalanceColor(remainingBalance)} order={4}>
          {formatter.format(remainingBalance)}
        </Title>
        <Group gap={4}>
          <Text c="dimmed" size="sm">
            {openInvoices.length}
          </Text>
          <Text c="dimmed" size="sm">
            {t(i18nKeys.CLIENT.GENERAL_INFO_TAB.OPEN_INVOICES)}
          </Text>
        </Group>
      </Stack>
    </Ticker>
  );
};
